export const curVersion = '1.0.60'
export const versionComment = [
  {
    version: '# 1.0.61 已更新(2026.07.20)',
    versionStr: `- [新增] 问题汇总界面增加统计面板，可直观的查看当前数据的多维度统计表`
  },
  {
    version: '# 1.0.60 已更新(2024.11.28)',
    versionStr: `- [新增] 下发时, 可先筛选版本, 再筛选企业`
  },
  {
    version: '# 1.0.59 已更新(2024.10.16)',
    versionStr: `- [新增] 详设功能增加表格、代码块等功能
    - [新增] 开发人员快捷筛选出所有未处理的问题功能`
  },
  {
    version: '# 1.0.58 已更新(2024.10.09)',
    versionStr: `- [新增] 新增详细设计功能`
  },
  {
    version: '# 1.0.57 已更新(2024.06.19)',
    versionStr: `- [优化] 汇总菜单提出日期的列筛选优化(因为源数据的日期是带时分秒, 导致实际值不同, 在数据层面将其格式化解决)`
  },
  {
    version: '# 1.0.56 已更新(2024.05.06)',
    versionStr: `- [优化] 调整错误等级权限控制`
  },
  {
    version: '# 1.0.55 已更新(2024.04.19)',
    versionStr: `- [优化] 数据处理若没有解决时间则按当日计算`
  },
  {
    version: '# 1.0.54 已更新(2024.03.26)',
    versionStr: `- [优化] 增加说明显示风格设置, 默认新的模式, 可在头像的系统设置中切换`
  },
  {
    version: '1.0.53 已更新(2024.03.21)',
    versionStr: `- [优化] 数据处理飘红判断修改, 规则改为: 如果提出时间和要求完成日期是同一天, 超过 24 小时解决则飘红; 如果不是同一天则维持原先的规则(按日期来判断)`
  },
  {
    version: '1.0.52 已更新(2024.03.15)',
    versionStr: `- [新增] 增加技术测试、业务测试天数超期飘红`
  },
  {
    version: '1.0.51 已更新(2024.02.27)',
    versionStr: `- [新增] 增加错误类型字段`
  },
  {
    version: '1.0.50 已更新(2023.10.10)',
    versionStr: `- [新增] 数据处理超期标红`
  },
  {
    version: '1.0.49 已更新(2023.07.17)',
    versionStr: `- [新增] 新增下发编号列`
  },
  {
    version: '1.0.48 已更新(2023.02.06)',
    versionStr: `- [新增] 历史问题汇总菜单
    - [新增] 问题汇总增加登记单位显示`
  },
  {
    version: '1.0.47 已更新(2023.01.28)',
    versionStr: `- [新增] 下发流程增加附件功能`
  },
  {
    version: '1.0.46 已更新(2023.01.10)',
    versionStr: `- [优化] 设计变更可直接通过双击对应单元格打开
    - [修复] 修复过滤框在输入搜索值并且未点击确认时，勾选状态显示错误的问题`
  },
  {
    version: '1.0.45 已更新(2022.12.16)',
    versionStr: `- [新增] 工作量合计`
  },
  {
    version: '1.0.44 已更新(2022.11.16)',
    versionStr: `- [新增] 增加系统操作日志
    - [新增] 汇总页面新增问题时默认提出人为当前人
    - [修复] 修复过滤框在和普通字符串搜索框共用时，报错的情况
    - [新增] 进入系统时获取 IP 地址
    - [优化] 数据处理增加特殊指派权限
    - [新增] 数据处理加入是否需要回滚字段`
  },
  {
    version: '1.0.43 已更新(2022.11.09)',
    versionStr: `- [优化] 数据处理 解决时可以传附件
    - [优化] 数据处理 single 显示登记单位信息
    - [优化] 数据处理 解决的时候可以传附件
    - [优化] 数据处理 问题状态增加已解决状态, 处理流程为：反馈系统同步协作系统 => 协作系统解决后反写完成日期至反馈系统 => 用户评价决定这条数据处理是否关闭/激活
    - [优化] 数据处理 特殊权限控制数据处理新增
    - [优化] 数据处理 增加要求完成日期字段`
  },
  {
    version: '1.0.42 已更新(2022.10.26)',
    versionStr: `- [优化] 新增设计变更功能
    - [新增] 新增 [BUG 提交] 菜单
    - [优化] 问题汇总导出优化 => 去除设计变更列、增加导出文件名`
  },
  {
    version: '1.0.41 已更新(2022.10.20)',
    versionStr: `- [特性] 添加协助人增加可修改问题内容、说明，并且关联源问题进行说明同步，任意协助问题驳回，全部问题都会被驳回
    - [优化] 优化更改解决人研发与测试冲突的问题，优化所有操作节点排序流转`
  },
  {
    version: '1.0.40 已更新(2022.10.10)',
    versionStr: `- [优化] 汇总界面：说明弹窗增加上一条、下一条查看功能`
  },
  {
    version: '1.0.39 已更新(2022.09.30)',
    versionStr: `- [修复] 修复模块菜单、下发流程分页的总数没显示
    - [优化] 下发流程增加上一条、下一条查看功能
    - [优化] 优化下发流程界面交互
    - [特性] 汇总界面：增加新增问题功能`
  },
  {
    version: '1.0.38 已更新(2022.09.20)',
    versionStr: `- [特性] 增加登录页 app 二维码下载`
  },
  {
    version: '1.0.37 已更新(2022.09.08)',
    versionStr: `- [优化] 汇总界面附件模式修改、增加预览`
  },
  {
    version: '1.0.36 已更新(2022.09.06)',
    versionStr: `- [优化] 汇总界面加分页`
  },
  {
    version: '1.0.35 已更新(2022.08.26)',
    versionStr: `- [优化] 增加系统版本特殊权限`
  },
  {
    version: '1.0.34 已更新(2022.08.12)',
    versionStr: `- [优化] 筛选数值时列表不显示数据的问题`
  },
  {
    version: '1.0.33 已更新(2022.08.02)',
    versionStr: `- [优化] 优化筛选列表的渲染模式`
  },
  {
    version: '1.0.32 已更新(2022.07.28)',
    versionStr: `- [特性] 全局 - 列头筛选的日期型进行排序
    - [特性] 下发 - 新增[复制单据]功能`
  },
  {
    version: '1.0.31 已更新(2022.07.27)',
    versionStr: `- [特性] 增加[接口分析]菜单`
  },
  {
    version: '1.0.30 已更新(2022.07.04)',
    versionStr: `- [特性] 汇总 - 附件上传改为单独特殊权限控制`
  },
  {
    version: '1.0.29 已更新(2022-07-01)',
    versionStr: `- [特性] 汇总 - 工作量评估时，若值为0则进行提示；区间值改为 0.1`
  },
  {
    version: '1.0.28 已更新(2022-06-23)',
    versionStr: `- [特性] 汇总 - 非本人也可新增说明，仅能新增[说明]类型`
  },
  {
    version: '1.0.27 已更新（2022-06-21）',
    versionStr: `- [特性] 下发 - 明细界面增加下发企业字段`
  },
  {
    version: '1.0.26 已更新（2022-06-06）',
    versionStr: `- [特性] 汇总 - 问题通过后除特殊权限外，不可修改人员(评价人列除外)`
  },
  {
    version: '1.0.25 已更新（2022-05-24）',
    versionStr: `- [特性] 下发流程被打回的checkList项，负责人行增加背景色区分`
  },
  {
    version: '1.0.24（2022-05-13）',
    versionStr: `- [特性] 下发流程增加字段：[要求下发日期]、[编号]
    - [特性] 下发流程主界面：根据[要求下发日期]判断[实际下发日期]字体颜色
    - [修复] 增加可下发类型：[超期已解决]`
  },
  {
    version: '1.0.23（2022-04-18）',
    versionStr: `- [修复] 确认下发后无反写回反馈系统的问题
    - [优化] 调整下发流程主界面的列顺序，加列头筛选`
  },
  {
    version: '1.0.22（2022-04-13）',
    versionStr: `- [优化] 问题汇总界面增加右键选中
    - [特性] 增加确认下发后，反写反馈系统`
  },
  {
    version: '1.0.21（2022-04-07）',
    versionStr: `- [修复] 优化登陆时创建路由方法
    - [优化] 修改动态创建路由
    - [优化] 流程下发界面的 checklist 高度调整为可滚动`
  },
  {
    version: '1.0.20（2022-04-01）',
    versionStr: `- [修复] 领导意见导出有乱码问题
    - [特性] 下发流程功能完成
    - [完善] 问题汇总界面增加字段：是否引用`
  },
  {
    version: '1.0.19（2022-03-21）',
    versionStr: `- [修复] 项目进度切换 tab 时表格可能存在抖动的问题
    - [完善] 增加数字范围筛选器，用于问题编号筛选
    - [完善] 问题汇总界面增加清空列头筛选按钮
    - [完善] 修复登录时问题汇总未处理提醒不生效的问题`
  },
  {
    version: '1.0.18（2022-03-09）',
    versionStr: `- [修复] 附件下载没名字
    - [修复] token 失效后，跳转回登录界面 loading 未关闭`
  },
  {
    version: '1.0.17（2022-03-01）',
    versionStr: `- [修复] 修复汇总页面表格滚动时会撕裂的问题
    - [完善] 待办事项增加颜色标识
    - [完善] 增加登录后，待办事项提示
    - [完善] 增加登录后，问题汇总提示`
  },
  {
    version: '1.0.16（2022-02-28）',
    versionStr: `[完善] 将待办事项默认节点改为'未完成'，并增加个人配置可自定义`
  },
  {
    version: '1.0.15（2022-02-20）',
    versionStr: `[完善] 项目进度若没有后端解决人显示为/`
  },
  {
    version: '1.0.14（2022-02-10）',
    versionStr: `- [完善] 若为提出人本人，则可以修改问题状态`
  },
  {
    version: '1.0.13（2022-02-07）',
    versionStr: `- [完善] 工作量评估时间限制改为提出日期一个月内可改`
  },
  {
    version: '1.0.12（2022-01-29）',
    versionStr: `- [完善] 优化一键排版的算法(仅按有序排列，例如: 1. 2. 3. 4. ...)
    - [完善] 问题汇总查看全部时，直接滑动到排序为 1 的位置
    - [完善] 问题汇总界面点击刷新刷剧后，保留筛选条件
    - [完善] 问题汇总界面暂时隐藏复选框列
    - [完善] 系统设置
    - [完善] 加前端、后端评价人`
  },
  {
    version: '1.0.11（2022-01-25）',
    versionStr: `- [BUG] 修复高级过滤框点击全选再选其他项后，其他项会消失的问题
    - [BUG] 修复新增说明时，多岗情况下会有重复的说明类型
    - [新增] 进度可以修改人员
    - [完善] 新增一键排版说明功能
    - [BUG] 修复进度页面修改人员按钮权限控制问题`
  },
  {
    version: '1.0.10（2022-01-24）',
    versionStr: `- [BUG] 截止日期需要能修改未来的日期`
  },
  {
    version: '1.0.9（2022-01-18）',
    versionStr: `- [完善] 进度看板页面，移除待测试 tab`
  },
  {
    version: '1.0.8（2022-01-17）',
    versionStr: `- [完善] "系统版本"列移动到"问题编号"和"模块"之间
    - [完善] 导出的"说明"列格式化，去除乱码
    - [修改] 汇总表附件优化
    - [新增] 新增进度表统计界面
    - [新增] 员工奖惩基础设置`
  },
  {
    version: '1.0.7（2022-01-13）',
    versionStr: `- [完善] "说明类型"测试人员加"不处理"选项；提出人加"驳回"选项；所有人加"说明"选项
    - [完善] "说明类型"改为限制必填
    - [完善] 加版本更新说明
    - [修改] 附件功能优化
    - [BUG] 增加协助的后端研发岗位绑定错误的问题
    - [修改] 复杂筛选增加数据格式化功能(本次修改日期、大小写查询)
    - [修改] element-ui 为按需引入，减少项目体积
    - [修改] 合并公共组件，减少项目体积
    - [BUG] 提出人确认后，不会刷新当前数据`
  },
  {
    version: '1.0.6（2022-01-12）',
    versionStr: `- [修改] 汇总附件模式修改 - [BUG]
          列头筛选搜索框输入和勾选框的联动 BUG 修复 - [完善]
          优化列头筛选同时多列进行筛选时的数据联动 - [完善]
          汇总界面修改人员时，限制必填`
  },
  {
    version: '1.0.5(2022-01-11)',
    versionStr: `- [BUG] 修复列头筛选切换时，筛选条件刷新不及时的问题
    - [BUG] 修复撤销签名时报错的问题
    - [完善] 列头筛选增加高级筛选条件（包含、不包含）
    - [BUG] 修复列头筛选框无法过滤数字的问题`
  },
  {
    version: '1.0.4(2022-01-10)',
    versionStr: `- [BUG] 修复列头筛选空值筛选不出来的问题
    - [BUG] 修复进度查看界面特殊权限获取失败的问题
    - [完善] 列头筛选加"仅筛选"功能；列头筛选操作体验优化`
  },
  {
    version: '1.0.3(2022-01-10)',
    versionStr: `- [完善] 进度表加类型字段（新增、完善）
    - [完善] 汇总界面增加修改问题模块、问题内容、系统版本功能
    - [完善] 汇总界面"当前节点"列加筛选功能
    - [完善] 汇总界面修改后只进行局部刷新，需点击"刷新"按钮才可全量刷新
    - [完善] 登录界面增加记住用户名和密码功能`
  },
  {
    version: '1.0.2(2022-01-07)',
    versionStr: `- [完善] 问题汇总界面固定列只固定到系统版本
    - [修复] 截止日期应可选未来的时间
    - [修复] 问题汇总界面说明编辑的权限问题修复
    - [完善] 问题汇总界面默认显示全部
    - [完善] 待办事项树节点调整、如没有我发起的自动跳转全部`
  },
  {
    version: '1.0.1(2022-01-07)',
    versionStr: `- [完善] 修改密码后弹窗需关闭
    - [完善] 增加协助人弹窗增加前后端过滤
    - [完善] 超级权限可以评估任何人的工作量
    - [修复] 问题汇总导入时未关联数据的问题
    - [新增] 待办事项菜单
    - [修复] vxepro 在公网无法正常使用`
  }
]
